<template>
  <div>
    <Main ref="main" :loading="loading" :tableData="tableData"> </Main>
  </div>
</template>
<script>
import Main from './main'
export default {
  props: {
    code: { type: String, default: '' },
    getData: { type: Function, default: () => {} },
  },
  components: { Main },
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  async mounted() {
    this.loading = true
    this.tableData = await this.getData(this.code)
    this.loading = false
  },
}
</script>
